import { useParams, useLocation } from "react-router-dom";
import Layout from "../../layouts/default";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { getDownloadFileLink } from "../../store/slices/exportFile/exportFile";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

function DownloadReportView() {
    const { uuid } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const query = new URLSearchParams(location.search);
    const hodublastAccount = query.get("hodublastAccount");
    const jobId = query.get("jobId");
    // [CAMPAIGN_CONTACTS_EXPORT] the emailed link uses ?exportType=...&requestUuid=...
    // so this page also serves campaign contacts exports (not just IVR failed export)
    const exportType = query.get("exportType");
    const requestUuid = query.get("requestUuid");
    const isCampaignContactsExport = exportType === "CAMPAIGN_CONTACTS_EXPORT";

    const handleDownloadCSV = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            if (!user) {
                toast.error("User not found. Please re-login.");
                return;
            }

            let payload;
            if (isCampaignContactsExport) {
                if (!uuid) {
                    toast.error("campaign uuid is missing.");
                    return;
                }
                payload = {
                    exportType,
                    campaignUuid: uuid,
                    requestUuid,
                    user: user?.data,
                };
            } else {
                if (!uuid || !jobId || !hodublastAccount) {
                    toast.error("uuid, jobId or hodublast account is missing.");
                    return;
                }
                payload = {
                    campaignUuid: uuid,
                    jobId,
                    hodublastAccount,
                    user: user?.data,
                };
            }

            setLoading(true);

            const res = await dispatch(getDownloadFileLink(payload)).unwrap();

            if (!res || !res.filePath) {
                toast.error("File not found or not ready.");
                setLoading(false);
                return;
            }

            const fileUrl = res.filePath;

            // Auto-download CSV file
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = isCampaignContactsExport
                ? `${uuid}_contacts.csv`
                : "ivr_failed_export.csv";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
        } catch (err) {
            console.log("Error in handleDownloadCSV:", err);
            const message = err?.message || "Internal server error.";
            toast.error(message);
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="d-flex justify-content-center mt-5">
                <div
                    style={{
                        width: "600px",
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "12px",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                    }}
                >
                    <h3 className="text-center" style={{ fontWeight: 600 }}>
                        {isCampaignContactsExport
                            ? "Campaign Contacted Numbers Download"
                            : "Campaign IVR Failed Contacts Report Download"}
                    </h3>

                    <p className="text-center text-muted mb-4" style={{ fontSize: "14px" }}>
                        Retrieve your processed export file for the selected campaign.
                    </p>

                    {/* Campaign Info */}
                    <div
                        style={{
                            background: "#f7f8fc",
                            padding: "15px 20px",
                            borderRadius: "8px",
                            border: "1px solid #e5e7eb",
                            marginBottom: "20px",
                        }}
                    >
                        <h6 style={{ fontWeight: 600, marginBottom: "12px" }}>
                            Campaign Information
                        </h6>

                        <div style={{ fontSize: "14px" }}>
                            <div className="mb-2">
                                <strong>Campaign UUID:</strong>
                                <div style={{ color: "#4b4fe2" }}>{uuid}</div>
                            </div>

                            {!isCampaignContactsExport && (
                                <>
                                    <div className="mb-2">
                                        <strong>HoduBlast Account:</strong>
                                        <div>{hodublastAccount}</div>
                                    </div>

                                    <div className="mb-2">
                                        <strong>Job ID:</strong>
                                        <div>{jobId}</div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Download Button */}
                    {
                        (isCampaignContactsExport || hasPermission(PERMISSIONS.IVR_CAMPAIGN_REPORT.DOWNLOAD)) && <div className="text-center">
                            <Button
                                onClick={handleDownloadCSV}
                                disabled={loading}
                                style={{ padding: "10px 35px", fontSize: "16px", borderRadius: "8px" }}
                            >
                                {loading ? (
                                    <>
                                        <Spinner size="sm" animation="border" className="me-2" />
                                        Processing...
                                    </>
                                ) : (
                                    "Download CSV"
                                )}
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </Layout>
    );

}

export default DownloadReportView;
